import * as React from 'react';
import {Redirect} from 'react-router';
import { Route, RouteProps } from 'react-router-dom';
import {connect} from 'react-redux';
import {Helmet} from 'react-helmet';

import {BaseApplicationState} from '@common/react/store';
import {BaseUser} from '@common/react/objects/BaseUser';
import { loadable, loadableDelay } from '@common/react/loadable/loadableSettings';
import SignalR from '@common/react/components/SignalR/SignalR';
import ErrorBoundaryWithSentry from '@common/react/components/UI/ErrorBoundaryWithSentry/ErrorBoundaryWithSentry';
import { RequestProvider } from '@common/react/components/RequestProvider/RequestProvider';

import {LogoLoaderPage} from '@commonTuna/react/components/UI/LogoLoader/LogoLoader';

const params = {
	fallback: <LogoLoaderPage/>
};

const DashboardLayout = loadable(
	() => loadableDelay(/* webpackChunkName: "DashboardLayout" */ import('@app/components/Layouts/DashboardLayout/DashboardLayout' )), params
);

interface Props extends RouteProps {
	component: any;
	redirectPath?: string;
	title?: string;
}

interface ReduxProps {
	user: BaseUser | null;
}

const DashboardRoute: React.FC<Props & ReduxProps> = ({ component: Component, user, redirectPath = '/', title, ...rest }) => (
	<Route
		{...rest}
		render={props => user ? <DashboardLayout>
			{title && <Helmet>
				<title>{title}</title>
			</Helmet>}
			<ErrorBoundaryWithSentry>
				<RequestProvider>
					<SignalR />
					<Component {...props} />
				</RequestProvider>
			</ErrorBoundaryWithSentry>
		</DashboardLayout> : <Redirect to={redirectPath} />}
	/>
);

export default connect<ReduxProps, {}, Props, BaseApplicationState<BaseUser>>(
	(state: BaseApplicationState<BaseUser>) => ({
		user: state.login.user
	})
)(DashboardRoute);
